export enum StoreModule {
  DIALOGS = "dialogs",
  ERRORS = "errors",
  SNACKBAR = "snackbar",
  MSP_DEVICES = "mspDevices",
  MSP_DRIVES = "mspDrives",
  MSP_TERMINAL = "mspTerminal",
  MSP_TICKETS = "mspTickets",
  MSP_TICKET_COMMENTS = "mspTicketComments",
  MSP_TREEVIEW = "mspTreeview",
  MSP_LABELS = "mspLabels",
  MSP_DASHBOARD = "mspDashboard",
  MSP_GLOBAL_POLICIES = "mspGlobalPolicies",
  SECURITY_AWARENESS = "securityAwareness",
  SCHEDULED_REPORTS = "scheduledReports",
  TUTORIAL = "tutorial",
  APPS_MGMT = "appsManagement",
  GLOBAL_WORKSPACES = "globalWorkspaces",
  DEVICE_SESSION = "deviceSession",
  WORKSPACES_LIST = "workspacesList",
  WORKSPACE = "workspace",
  PERMISSIONS = "permissions",
  USER_LABELS = "userLabels",
  ACCOUNT = "account",
  WEBSOCKET = "socket",
  MY_ACCOUNT = "myAccount",
  REDIRECTS = "redirects",
  COMMON_NETWORK_SETTINGS = "commonNetworkSettings",
  NETWORK_MODULE_SETTINGS = "networkModuleSettings",
  DEVICE_SETTINGS = "devicesSettings",
  GATEWAY_SETTINGS = "gatewaySettings",
  DEVICE_POSTURE_SETTINGS = "devicePostureSettings",
  CLOUD_APPS_SETTINGS = "cloudAppsSettings",
  ENDPOINT_SECURITY_ALLOW_BLOCK_LIST = "endpointSecurityAllowBlockList",
  EDR_ALLOW_BLOCK_LIST = "edrAllowBlockList",
  DISCOVERY_STATS = "discoveryStats",
  ACCESS_PERMISSIONS = "accessPermissions",
  MALWARE_SCAN = "malwareScan",
  SYSLOGS = "syslogs",
  CORO_IMPACT = "coroImpact",
  MSP_CORO_IMPACT = "mspCoroImpact",
  MSP_EXPORTS = "mspExports",
  AI_ASSISTANT = "aiAssistant",
  CUSTOM_DOMAIN_DNS = "customDomainDns",
  MSP_EMAIL_SECURITY_ALLOW_BLOCK_LIST = "mspEmailSecurityAllowBlockList",
  EDR_SETTINGS = "edrSettings",
  MSP_ENDPOINT_SECURITY_ALLOW_BLOCK_LIST = "mspEndpointSecurityAllowBlockList",
  MSP_EDR_ALLOW_BLOCK_LIST = "mspEdrAllowBlockList",
  SINGLE_VIEW_DASHBOARD = "singleViewDashboard",
  DEVICES = "devices",
  GLOBAL_ALLOW_BLOCK_LIST = "globalAllowBlockListStore",
  SETUP_HUB = "setupHub",
  SIDEBAR_PANEL = "sidebarPanel",
  ACTIVE_SESSIONS = "activeSessions",
  ACTIVITY_LOGS = "activityLogs",
  ADMIN_USERS = "adminUsers",
  API_CREDENTIALS = "apiCredentials",
  BACK_OFFICE = "backOffice",
  CLOUD_APPS = "cloudApps",
  DOWNLOADS = "downloads",
  EMAIL_PROXY_STORE = "emailProxyStore",
  EMAIL_SETTINGS_STORE = "emailSettingsStore",
  EXPORTS = "exports",
  FILTERS = "filters",
  MESSAGES = "messages",
  MFA = "mfa",
  MOBILE_ACTIVATION = "mobileActivation",
  MSP = "msp",
  MSP_ADMIN_USERS = "mspAdminUsers",
  MSP_USERS = "mspUsers",
  PRIVACY_SENSITIVE_DATA = "privacySensitiveData",
  PROCESS_GRAPH = "processGraph",
  PROCESSES = "processes",
  PSA = "psa",
  REPORTS = "reports",
  SECURE_WEB_GATEWAY = "secureWebGateway",
  SECURITY_GAPS = "securityGaps",
  SELECTOR = "selector",
  SENSITIVE_DATA_SCANS = "sensitiveDataScans",
  SETTINGS = "settings",
  SIEM = "siem",
  SITE_TO_SITE_TUNNELS = "siteToSiteTunnels",
  SOC_CONTACT = "socContact",
  SOC_REMEDIATION = "socRemediation",
  TELEMETRY = "telemetry",
  TERMINAL = "terminal",
  THIRD_PARTY_APPS = "thirdPartyApps",
  TICKET = "ticket",
  TICKET_COMMENTS = "ticketComments",
  TICKETS = "tickets",
  USER_DATA_GOVERNANCE_MODULE = "userDataGovernanceModule",
  USERS = "users",
  USERS_EXCEPTIONS_TAB = "usersExceptionsTab",
  USERS_GROUPS_TAB = "usersGroupsTab",
  USERS_SETTINGS = "usersSettings",
  USERS_SETTINGS_TAB = "usersSettingsTab",
  VIRTUAL_OFFICE = "virtualOffice",
  WEBHOOKS = "webhooks",
  ZTNA = "ztna",
  APP_CONFIG = "appConfig",
}
